import React, { useEffect } from 'react';
import { styled } from "@mui/material/styles";
import {
  Autocomplete,
  TextField,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import CustomModal from '../Modal/index';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import AddLinkIcon from '@mui/icons-material/AddLink';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import TrashIcon from '@mui/icons-material/Delete';
import { GlobalButton, GlobalSecondaryButton } from "../../pages/styles";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  DatePickerKeyDownEvent,
  normalizeMidasNumberForFiltering,
} from '../../global';
import ModalTwoButtons from '../Modal/ModalTwoButtons';
import { useUser } from '../../context/UserContext';
import FilterCriteria from '../../api/Global/FilterCriteria';
import ModalSimpleButton from '../Modal/ModalSimpleButton';

const fontSize = 14

const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
    fontSize: fontSize,
  },
});

const Option = styled('li')({
  fontSize: fontSize,
});

function getOperators(type) {
  switch (type) {
    case 'midasNumber':
      return (['=', 'like'])

    case 'string':
      return (['=', 'like'])

    case 'integer':
      return (['=', 'like', '>', '<', '>=', '<='])

    case 'enum':
      return (['='])

    case 'boolean':
      return (['='])

    case 'date':
      return (['=', '>', '<'])

    default: return (['=', 'like'])
  }
}


const FilterQueryMenu = ({ open, setOpen, applyBtnAction, cancelButtonAction, filteringInfo, appliedFilters, setAppliedFilters, moduleName = "" }) => {
  const hydrateFilters = (filters) => filters.map((filter) => {
    const matchingFilterInfo = filteringInfo.find((info) => info.name === filter.name);
    return {
      ...filter,
      type: filter.type ?? matchingFilterInfo?.type ?? null,
      nullable: filter.nullable ?? matchingFilterInfo?.nullable ?? false,
    };
  });

  const [availableOperators, setAvailableOperators] = React.useState([])
  const [selectedFilters, setSelectedFilters] = React.useState(appliedFilters)
  const [myFilters, setMyFilters] = React.useState([]);
  const [myFiltersLoading, setMyFiltersLoading] = React.useState(false);
  const [myFilterSelectedId, setMyFilterSelectedId] = React.useState(null);
  const [openModalSaveFilter, setOpenModalSaveFilter] = React.useState(false);
  const [filterToEdit, setFilterToEdit] = React.useState(null);
  const [filterName, setFilterName] = React.useState('');
  const [isDefault, setIsDefault] = React.useState(false);
  const [modalMessagesOpen, setModalMessagesOpen] = React.useState(false);
  const [modalMessagesText, setModalMessagesText] = React.useState("");
  const [modalMessagesTitle, setModalMessagesTitle] = React.useState("");
  const [modalMessagesButtonText, setModalMessagesButtonText] = React.useState("Ok");

  const { username: userEmail } = useUser();

  function getFiltersByModuleAndUser() {
    setMyFiltersLoading(true);

    FilterCriteria.getByModule(moduleName).then((res) => {
      setMyFiltersLoading(false);

      const filters = res.map(filter => ({
        ...filter,
        filterPayload: JSON.parse(filter.filterPayload)
      }))
      setMyFilters(filters);
      const filterDefault = filters.find(f => f.isDefault);
      if (filterDefault) handleChangeMyFilterSelected(filterDefault, true);
    })
  }

  useEffect(() => {
    getFiltersByModuleAndUser();
    // eslint-disable-next-line
  }, [moduleName])

  useEffect(() => {
    setSelectedFilters(hydrateFilters(appliedFilters))
    const filterDefault = myFilters.find(f => f.isDefault);
    if (filterDefault && !appliedFilters.some(s => s.name && s.name !== '')) handleChangeMyFilterSelected(filterDefault);
    // eslint-disable-next-line
  }, [appliedFilters, open])

  const addFilterRow = (e) => {
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))
    newFilters.push({ name: null, displayName: null, operator: null, join: '&&', enumValues: [], value: null, startGroup: false, endGroup: false })

    setSelectedFilters(newFilters)
  }

  const handleColValueChange = (index, value) => {
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))

    if (value && newFilters[index].name === value.name) {
      return
    }

    newFilters[index].name = !(value === null) ? value.name : null
    newFilters[index].displayName = !(value === null) ? value.displayName : null
    newFilters[index].operator = null
    newFilters[index].value = ''
    newFilters[index].type = value?.type ?? null
    newFilters[index].nullable = value?.nullable ?? false

    const operators = JSON.parse(JSON.stringify(availableOperators))

    operators[index] = getOperators(!(value === null) ? value.type : null)

    if (!(value === null) && value.type === 'enum') {
      newFilters[index].enumValues = value.enumValues
    } else {
      newFilters[index].enumValues = []
    }

    setAvailableOperators(operators)
    setSelectedFilters(newFilters)
  }

  const handleFreeText = (index, value) => {
    const info = filteringInfo.filter(oInfo => oInfo.name === selectedFilters[index].name)
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))

    if (info && info.length > 0 && info[0].type === 'integer') {
      newFilters[index].value = Number.isInteger ? parseInt(value) : value
    } else {
      newFilters[index].value = value
    }

    setSelectedFilters(newFilters)
  }

  const removeFilterRow = (e, index) => {
    let newFilters = JSON.parse(JSON.stringify(selectedFilters))
    const operators = JSON.parse(JSON.stringify(availableOperators))

    // if (selectedFilters[0].endGroup || selectedFilters[0].startGroup) {
    //   newFilters = removeGroupRow(selectedFilters[0], index, false)
    // }

    newFilters.splice(index, 1)
    operators.splice(index, 1)

    setSelectedFilters(newFilters)
    setAvailableOperators(operators)
  }

  const addGroupRow = (row, index) => {
    const filterGroup = selectedFilters.filter((f, fIndex) => f.endGroup && fIndex < index);
    const lastFilterGroup = filterGroup.slice(-1).pop();
    const lastIndexGroup = selectedFilters.findIndex(i => i === lastFilterGroup);

    const newFilters = selectedFilters.map((filter, indexFilter) => {
      if (lastIndexGroup + 1 === indexFilter || (lastIndexGroup === -1 && indexFilter === 0)) {
        return {
          ...filter,
          startGroup: true,
          endGroup: index === 0 ? true : false
        }
      } else if (index === indexFilter) {
        return {
          ...filter,
          endGroup: true
        }
      }
      return filter;
    })

    setSelectedFilters(newFilters)
  }

  const removeGroupRow = (row, index, setFilter = true) => {
    const filterGroup = selectedFilters.filter((f, fIndex) => row.endGroup ? f.startGroup : f.endGroup && fIndex < index);
    const lastFilterGroup = filterGroup.slice(-1).pop();
    const lastIndexGroup = selectedFilters.findIndex(i => i === lastFilterGroup);

    const newFilters = selectedFilters.map((filter, indexFilter) => {
      if (lastIndexGroup === indexFilter) {
        return {
          ...filter,
          startGroup: false,
          endGroup: false
        }
      } else if (index === indexFilter) {
        return {
          ...filter,
          startGroup: false,
          endGroup: false
        }
      }
      return filter;
    })

    if (setFilter) setSelectedFilters(newFilters)

    return newFilters;
  }

  const mountFilters = () => {
    var prettyFilters = []
    var prettyOperators = []

    availableOperators.forEach(element => {
      prettyOperators.push(element)
    })

    selectedFilters.forEach(element => {
      if (!(element.name === null) && !(element.operator === null) && !(element.value === null)) {
        prettyFilters.push(element)
      }

    });

    return [prettyFilters, prettyOperators];
  }

  const hasFilter = () => {
    const [prettyFilters] = mountFilters();
    return prettyFilters && prettyFilters.length > 0;
  }

  const applyFilters = () => {
    const [prettyFilters, prettyOperators] = mountFilters();

    if (prettyFilters && prettyFilters.length > 0) {
      setAppliedFilters(prettyFilters)
    }

    setAvailableOperators(prettyOperators)
    applyBtnAction()
  }


  const ConvertMidasNumbers = (rowIndex) => {
    const info = filteringInfo.find(oInfo => oInfo.name === selectedFilters[rowIndex].name)
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))

    if (info?.type === 'midasNumber' && newFilters[rowIndex].value) {
      newFilters[rowIndex].value = normalizeMidasNumberForFiltering(newFilters[rowIndex].value)
    }

    setSelectedFilters(newFilters)
  }

  const handleOperatorChange = (index, value) => {
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))
    newFilters[index].operator = value

    setSelectedFilters(newFilters)
  }

  const handleEnumSelection = (index, value) => {
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))
    newFilters[index].value = value

    setSelectedFilters(newFilters)
  }

  const handleJoinChange = (index, value) => {
    const newFilters = JSON.parse(JSON.stringify(selectedFilters))
    newFilters[index].join = value

    setSelectedFilters(newFilters)
  }

  const getFieldValue = (oFilter, index) => {
    if (oFilter.enumValues.length < 1) {
      const info = filteringInfo.find(oInfo => oInfo.name === selectedFilters[index].name)

      if (info?.type === 'boolean') {
        return <StyledAutocomplete
          renderOption={(props2, option) => (
            <Option {...props2}>{option}</Option>
          )}
          disablePortal
          options={['true', 'false']}
          getOptionLabel={(option) => option}
          onChange={(e, value) => handleEnumSelection(index, value)}
          value={oFilter.value === '' ? null : oFilter.value}
          isOptionEqualToValue={(option, value) => value === option}
          autoHighlight
          autoSelect
          renderInput={(params) => <TextField {...params} style={{ width: "200px", marginRight: "10px", marginTop: "10px" }} variant="outlined" size="small" label="Select Value" inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }} InputProps={{ ...params.InputProps }} />}
        />
      } else if (info?.type === "date") {
        return (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              disabled={oFilter.operator === null}
              size="small"
              inputFormat="MM/dd/yyyy"
              label="Search Date"
              onChange={e => handleFreeText(index, e)}
              value={oFilter.value ?? null}
              renderInput={(params) => <TextField
                onKeyDown={DatePickerKeyDownEvent}
                {...params}
                style={{ width: "200px", marginTop: "10px" }}
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: true, style: { fontSize: fontSize } }}
                inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }}
                InputProps={{ ...params.InputProps, style: { fontSize: fontSize } }}
              />}
            />
          </LocalizationProvider>
        )
      }
      return (<TextField style={{ width: "200px", marginTop: "10px" }}
        size="small"
        variant="outlined"
        label="Search Value"
        inputProps={{ style: { fontSize: fontSize } }}
        InputLabelProps={{ style: { fontSize: fontSize } }}
        InputProps={{ style: { fontSize: fontSize } }}
        value={oFilter?.value ?? ''}
        onChange={(e) => handleFreeText(index, (e.target.value))}
        onBlur={() => ConvertMidasNumbers(index)}
      />)
    } else {
      return <StyledAutocomplete
        renderOption={(props2, option) => (
          <Option {...props2}>{option}</Option>
        )}
        //disablePortal
        disabled={oFilter.operator === null}
        options={oFilter.enumValues}
        getOptionLabel={(option) => option}
        onChange={(e, value) => handleEnumSelection(index, value)}
        value={oFilter.value === '' ? null : oFilter.value}
        isOptionEqualToValue={(option, value) => value === option}
        autoHighlight
        autoSelect
        renderInput={(params) => <TextField {...params} style={{ width: "200px", marginRight: "10px", marginTop: "10px" }} variant="outlined" size="small" label="Search Value" inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }} InputProps={{ ...params.InputProps }} />}
      />
    }
  }

  async function createFilters(filterObject) {
    const payload = mountFilters();

    const object = {
      ...filterObject,
      filterModuleName: moduleName,
      filterPayload: JSON.stringify(payload),
      userEmail: userEmail,
    }

    try {
      const result = await FilterCriteria.create(object);
      if (result) {
        const newList = myFilters;

        newList.push({
          ...result,
          filterPayload: payload,
        });

        setMyFilters(newList);
        setMyFilterSelectedId(result.id);
        openModalMessages('Filter Created', 'Filter successfully created');
        getFiltersByModuleAndUser();
      } else {
        openModalMessages('Error Creating', 'Error creating filter\nPlease try again or contact support.');
      }
    } catch (error) {
      openModalMessages('Error Creating', error?.message);
    }
  }

  async function updateFilters(filterObject) {
    const payload = mountFilters();

    if (filterObject) {
      const object = {
        ...filterObject,
        filterPayload: JSON.stringify(payload),
      }

      try {
        const result = await FilterCriteria.update(object);
        if (result) {
          const newList = myFilters.filter(f => f.id !== result.id);

          newList.push({
            ...result,
            filterPayload: payload,
          });

          setMyFilters(newList);
          openModalMessages('Filter Updated', 'Filter successfully updated');
          getFiltersByModuleAndUser();
        }
        else {
          openModalMessages('Error Updating', 'Error updating filter\nPlease try again or contact support.');
        }
      } catch (error) {
        openModalMessages('Error Updating', error?.message);
      }
    }
  }

  async function deleteMyFilter(id) {
    try {
      await FilterCriteria.delete(id);
      setMyFilters([...myFilters.filter(f => f.id !== id)]);
      openModalMessages('Filter Deleted', 'Filter successfully deleted');
      setMyFilterSelectedId(null);
    } catch (error) {
      openModalMessages('Error Deleting', error?.message);
    }
  }

  function handleChangeMyFilterSelected(myFilter, applyFilters = false) {
    setMyFilterSelectedId(myFilter?.id)
    if (myFilter) {
      const [prettyFilters, prettyOperators] = myFilter.filterPayload;
      if (myFilter.filterPayload && myFilter.filterPayload?.length > 0) {
        const hydratedFilters = hydrateFilters(prettyFilters);
        setSelectedFilters(hydratedFilters);
        setAvailableOperators(prettyOperators);

        if (applyFilters) {
          if (hydratedFilters && hydratedFilters.length > 0) {
            setAppliedFilters(hydratedFilters)
          }
          applyBtnAction()
        }
      }
    }
  }

  function handleOpenModalSaveFilter(value, filter = null) {
    if (filter) {
      setFilterName(filter.filterName);
      setIsDefault(filter.isDefault);
    } else {
      setFilterName('');
      setIsDefault(false);
    }
    setFilterToEdit(filter);
    setOpenModalSaveFilter(value);
  }

  function openModalMessages(title, text) {
    setModalMessagesOpen(true);
    setModalMessagesTitle(title);
    setModalMessagesText(text);
    setModalMessagesButtonText("Ok");
  }

  function closeModalMessages() {
    setModalMessagesOpen(false);
    setModalMessagesText("");
    setModalMessagesButtonText("");
    setModalMessagesTitle("");
  }

  let groupNumber = 0;

  return (
    <>
      <CustomModal title={"Filtering Criteria"} open={open} setOpen={setOpen}>
        {moduleName !== '' && <div style={{
          display: "flex",
          justifyContent: "center",
          gap: 10,
          marginTop: 10,
        }}>
          <StyledAutocomplete
            renderOption={(props2, option) => (
              <Option {...props2}>{option.filterName}{option.isDefault ? ' (Default)' : ''}</Option>
            )}
            loading={myFiltersLoading}
            options={myFilters.sort((a, b) => a.filterName.localeCompare(b.filterName))}
            onChange={(e, value) => handleChangeMyFilterSelected(value)}
            value={myFilterSelectedId ?? null}
            isOptionEqualToValue={(option, value) => value?.id === option?.id}
            autoHighlight
            autoSelect
            style={{ width: "100%", ...styled }}
            getOptionLabel={(option) =>
              option?.filterName ?? myFilters.find((f) => f?.id === option)?.filterName ?? ""
            }
            renderInput={(params) => <TextField {...params} variant="outlined" size="small" label="My Filters" inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }} InputProps={{ ...params.InputProps }} />}
          />
          <GlobalButton
            style={{
              width: 150,
              fontSize: "14px",
              fontFamily: "EMprint",
              textTransform: "none"
            }}
            variant='contained'
            onClick={() => {
              const filterObject = myFilterSelectedId ? myFilters.find(f => f.id === myFilterSelectedId) : null;

              handleOpenModalSaveFilter(true, filterObject)
            }}
            disabled={!hasFilter()}
          >{myFilterSelectedId ? 'Update' : 'Create'}</GlobalButton>

          <GlobalSecondaryButton
            style={{
              fontSize: "14px",
              fontFamily: "EMprint",
              textTransform: "none"
            }}
            variant='contained'
            onClick={() => deleteMyFilter(myFilterSelectedId)}
            disabled={!myFilterSelectedId}
          >Delete</GlobalSecondaryButton>
        </div>}
        {selectedFilters && selectedFilters.map((oFilter, index) => {
          const lastFilter = selectedFilters[index - 1];
          const hasGroupAfter = selectedFilters.some((f, fIndex) => f.startGroup && fIndex > index);
          const startGroup = selectedFilters.some((f, fIndex) => f.startGroup && fIndex < index);
          const endGroup = selectedFilters.some((f, fIndex) => f.endGroup && fIndex > index);
          const hasGroup = startGroup && endGroup;

          groupNumber = oFilter.endGroup ? groupNumber + 1 : groupNumber;
          return (
            <>
              <div key={'myDiv' + index} style={{ display: "flex" }}>

                <StyledAutocomplete
                  renderOption={(props2, option) => (
                    <Option {...props2}>{option.displayName}</Option>
                  )}
                  disablePortal
                  options={filteringInfo}
                  getOptionLabel={(option) => option.displayName ? option.displayName : option}
                  onChange={(e, value) => handleColValueChange(index, value)}
                  value={oFilter.displayName}
                  isOptionEqualToValue={(option, value) => value === option.displayName}
                  autoHighlight
                  autoSelect
                  renderInput={(params) => <TextField {...params} style={{ width: "220px", marginRight: "10px", marginTop: "10px" }} variant="outlined" size="small" label="Column Name" inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }} InputProps={{ ...params.InputProps }} />}
                />

                <StyledAutocomplete
                  renderOption={(props2, option) => (
                    <Option {...props2}>{option}</Option>
                  )}
                  disablePortal
                  disabled={availableOperators[index] === undefined}
                  options={availableOperators[index] === undefined ? [] : availableOperators[index]}
                  getOptionLabel={(option) => option}
                  onChange={(e, value) => handleOperatorChange(index, value)}
                  value={oFilter.operator}
                  isOptionEqualToValue={(option, value) => value === option}
                  autoHighlight
                  autoSelect
                  renderInput={(params) => <TextField {...params} style={{ width: "150px", marginRight: "10px", marginTop: "10px" }} variant="outlined" size="small" label="Operator" inputProps={{ ...params.inputProps, style: { fontSize: fontSize } }} InputProps={{ ...params.InputProps }} />}
                />
                {getFieldValue(oFilter, index)}

                {index === selectedFilters.length - 1 &&
                  <Tooltip title={"Add Addtional Filter"} placement="bottom">
                    <AddIcon style={{
                      paddingBottom: "5px",
                      paddingLeft: "15px",
                      fontSize: 40,
                      marginTop: "10px"
                    }}
                      onClick={(e) => addFilterRow(e)}
                    ></AddIcon>
                  </Tooltip>
                }

                {index >= 0 && !lastFilter?.endGroup && !lastFilter?.startGroup && !oFilter?.endGroup && !oFilter?.startGroup && !hasGroup &&
                  <Tooltip title={"Add Group"} placement="bottom">
                    <AddLinkIcon style={{
                      paddingBottom: "5px",
                      paddingLeft: "15px",
                      fontSize: 40,
                      marginTop: "10px"
                    }}
                      onClick={(e) => addGroupRow(oFilter, index)}
                    ></AddLinkIcon>
                  </Tooltip>
                }

                {oFilter?.endGroup && !hasGroupAfter &&
                  <Tooltip title={"Remove Group"} placement="bottom">
                    <LinkOffIcon style={{
                      paddingBottom: "5px",
                      paddingLeft: "15px",
                      fontSize: 40,
                      marginTop: "10px"
                    }}
                      onClick={(e) => removeGroupRow(oFilter, index)}
                    ></LinkOffIcon>
                  </Tooltip>
                }

                {index > 0 && !oFilter.startGroup && !oFilter.endGroup &&
                  <Tooltip title={"Remove Filter"} placement="bottom">
                    <TrashIcon style={{
                      paddingBottom: "5px",
                      paddingLeft: "15px",
                      fontSize: 40,
                      marginTop: "10px"
                    }}
                      onClick={(e) => removeFilterRow(e, index)}
                    ></TrashIcon>
                  </Tooltip>
                }

              </div>
              {oFilter.endGroup && <div style={{ paddingTop: '10px', paddingBottom: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <span >Group {groupNumber}</span>
                <hr />
              </div>}
              {selectedFilters[index + 1] && <div key={'myDivRadio' + index} style={{ display: "flex", justifyContent: "center", paddingTop: "5px" }}>
                <RadioGroup
                  row
                  aria-labelledby="join-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel value="&&" checked={oFilter.join === "&&"} control={<Radio />} label="And" onChange={(e) => handleJoinChange(index, e.target.value)} />
                  <FormControlLabel value="||" checked={oFilter.join === "||"} control={<Radio />} label="Or" onChange={(e) => handleJoinChange(index, e.target.value)} />
                  <FormControlLabel value="&& !" checked={oFilter.join === "&& !"} control={<Radio />} label="And Not" onChange={(e) => handleJoinChange(index, e.target.value)} />
                  <FormControlLabel value="|| !" checked={oFilter.join === "|| !"} control={<Radio />} label="Or Not" onChange={(e) => handleJoinChange(index, e.target.value)} />
                </RadioGroup>
              </div>}
            </>
          )
        })}

        <div style={{
          display: "flex",
          justifyContent: "center",
        }}>

          <GlobalButton
            style={{
              marginTop: "35px",
              marginLeft: "6px",
              fontSize: "14px",
              fontFamily: "EMprint",
              textTransform: "none"
            }}
            variant='contained'
            onClick={() => applyFilters()}
          >Apply</GlobalButton>

          <GlobalSecondaryButton
            style={{
              marginTop: "35px",
              marginLeft: "20px",
              fontSize: "14px",
              fontFamily: "EMprint",
              textTransform: "none"
            }}
            variant='contained'
            onClick={cancelButtonAction}
          >Cancel</GlobalSecondaryButton>

        </div>

      </CustomModal>
      <ModalTwoButtons
        title={`${filterToEdit ? 'Update' : 'Create'} Filter`}
        button1Text={filterToEdit ? 'Update' : 'Create'}
        button1Action={() => {
          filterToEdit ? updateFilters({
            ...filterToEdit,
            filterName,
            isDefault
          }) : createFilters({
            filterName,
            isDefault
          });
          handleOpenModalSaveFilter(false);
        }}
        button2Text={'Cancel'}
        button2Action={() => handleOpenModalSaveFilter(false)}
        open={openModalSaveFilter}
        setOpen={handleOpenModalSaveFilter}
      >
        <div style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          marginTop: 10
        }}>
          <TextField
            style={{ width: "200px" }}
            size="small"
            variant="outlined"
            label="Filter Name"
            inputProps={{ style: { fontSize: fontSize } }}
            InputLabelProps={{ style: { fontSize: fontSize } }}
            InputProps={{ style: { fontSize: fontSize } }}
            value={filterName ?? ''}
            onChange={(e) => setFilterName(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isDefault}
                onChange={(e) => setIsDefault(!isDefault)}
              ></Checkbox>
            }
            label={"Is Default?"}
          />
        </div>
      </ModalTwoButtons>
      <ModalSimpleButton
        title={modalMessagesTitle}
        buttonText={modalMessagesButtonText}
        buttonAction={closeModalMessages}
        open={modalMessagesOpen}
        setOpen={setModalMessagesOpen}
      >
        <label style={{ whiteSpace: "break-spaces" }}>
          {modalMessagesText}
        </label>
      </ModalSimpleButton>
    </>
  );
}
export default FilterQueryMenu;


